import React from 'react'
import ContentLoader from 'react-content-loader'
import classes from './CardLoader.module.css'
import classNames from 'classnames'

const CardLoader = ({ className = '' }) => {
    return (
        <ContentLoader className={classNames(classes.loader, className)}>
            <rect width={'90%'} height={'240px'} x={'5%'} y={'10px'} />
            <rect
                width={'90%'}
                height={'15px'}
                x={'5%'}
                y={'270px'}
                rx={6}
                ry={6}
            />
            <rect
                width={'60%'}
                height={'10px'}
                x={'5%'}
                y={'295px'}
                rx={3}
                ry={3}
            />
        </ContentLoader>
    )
}

export const ProgressLoader = ({ className = '' }) => (
    <ContentLoader className={classNames(classes.progressLoader, className)}>
        <rect
            width={'152px'}
            height={'125px'}
            y={'12px'}
            x={'12px'}
            rx={'10'}
            ry={'10'}
        />
        <rect x={185} y={26} width={120} rx={2} ry={2} height={10} />
        <rect x={185} width={180} y={48} rx={2} ry={2} height={10} />
        <rect x={185} width={240} y={70} rx={5} ry={5} height={8} />
        <rect x={185} width={140} y={90} rx={16} ry={16} height={36} />
    </ContentLoader>
)

export const ProgressLoaderRow = () => (
    <div className={classes.loaderRow}>
        <ProgressLoader />
        <ProgressLoader />
    </div>
)

export default CardLoader
